import React, {useState, useEffect} from 'react'
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { useSelector, useDispatch } from 'react-redux';
import { wsUrl } from '../constants/global';
import allActions from '../actions/index';
//import client  from './WebSocketConnect';
//import notify from './common/Notification';
import {useNavigate} from "react-router-dom";
import Player from '@vimeo/player';
//import { liveVideoTracking } from './common/Tracking';

var client;

const OwnWebSocket = () => {

    //console.log("Websocket run");

    const websocketbucketState =  useSelector(state => state.WebSocketBucket);
    //console.log(websocketbucketState, 'Websocket bucket');
    const dispatch = useDispatch();

    useEffect(() => {
            //console.log("Websocket user Effect");
            if(websocketbucketState.flag == false ){
                //console.log("Websocket user Effect false matched");
                client = null;
                //console.log(wsUrl);
                client = new W3CWebSocket(wsUrl);
                //dispatch(allActions.webSocketFunc.webSocketFunc(true));

                //console.log( 'In own webscoket');
            
                client.onopen = () => {
            
                    let authlogin = localStorage.getItem('authlogin');
                    let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";
            
                    var storageCiisummit = localStorage.getItem('_ciisummit');
                    console.log('open connection');
                    var data = {
                        // targetPageId: 22,
                        //user_ip_address: window.socket.remoteAddress,
                        user_agent: window.navigator.userAgent,
                        receiver_email: storageDataAuthLogin.user_email,
                        cookie_id: storageCiisummit,
                        action: 'initConnection'
                        };
                        //console.log('WebSocket Client Connected');
                        //console.log(data);
                     
                        dispatch(allActions.webSocketFunc.webSocketFunc(true));

                        client.send(JSON.stringify(data));

                        // console.log("live video tracking");

                        // liveVideoTracking(client);
                };
                
                
                client.onmessage = (message) => {
                    
                    const dataFromServer = JSON.parse(message.data);
            
                    //console.log(dataFromServer.status);
                    
                    var adsArray = [];
            
                    if(dataFromServer.status=='pushAdminToUser'){
                        /********Push Admin Advertise To User**********/
                        const popupData = dataFromServer.data;
            
                        var adsObj = {};
                        /*******For Desktop ads********/
                        adsObj["desktop_left"] = {data: popupData.left_side_adv, popupname: popupData.left_popup_name};
            
                        adsObj["desktop_right"] = {data: popupData.right_side_adv, popupname: popupData.right_popup_name};
            
                        /*******For Mobile ads********/
                        adsObj["mobile_top"] = {data: popupData.mobile_top_adv, popupname: popupData.left_popup_name};
            
                        adsObj["mobile_bottom"] = {data: popupData.mobile_bottom_adv, popupname: popupData.right_popup_name};
            
                        adsArray.push(adsObj);
            
                        dispatch( allActions.Home.setHomeAdsData(adsObj));
            
                        //console.log(popupData, 'push Admin Advertise To User');
            
                        /********Push data in left modal popup*******/
                        if(popupData.left_popup_name != 0){
                            
                            dispatch( allActions.ModalPopup.pushPopupData({image:popupData.left_popup_data_image,title:popupData.left_popup_data_title,download_link:popupData.left_popup_name_data_link,popupname:popupData.left_popup_name}));
            
                        }
            
                        /*******Push data in right modal popup*******/
                        if(popupData.right_popup_name != 0){
                            
                            dispatch( allActions.ModalPopup.pushPopupData({image:popupData.right_popup_data_image,title:popupData.right_popup_data_title,download_link:popupData.right_popup_name_data_link,popupname:popupData.right_popup_name}));
                            
                        }
            
                    }else if(dataFromServer.status=='pushAdminToUserVideo'){
            
                        /**********Push Home screen video to user**************/
                    
                        const videofromserver = dataFromServer.data.ct_home_video;
            
                        dispatch( allActions.Home.setHomeVideoData(videofromserver));
            
                    }else if(dataFromServer.status=='imagePushToUser'){
            
                        /*************Data HTML Push to User**************/
                    
                        const popupData = dataFromServer.data.img_content;
            
                        //console.log(popupData, 'Data Push To User');
            
                        dispatch( allActions.ModalPopup.showPopup({ popupname:'datacontent', content: popupData}));
            
                    }else if(dataFromServer.status=='popupByPopupIDToUser'){
            
                        /***********Push Popups to user*************/
                    
                        const popupData = dataFromServer.data;
            
                        //console.log(popupData, "popupByPopupIDToUser", popupData.popupname);
            
                        /******Append data and direct show to user********/
                        dispatch( allActions.ModalPopup.showPopup(popupData));
            
                    }else if(dataFromServer.status=='notificationPushToUser'){
                        
                        var notificationData = dataFromServer.data;
            
                        dispatch( allActions.Notification.addNotification(notificationData.notification));
                    
                    }else if(dataFromServer.status=='updateKnowledgeCenter'){
                        
                        /********set Knowledge Center Datatrack********/
                        dispatch( allActions.KnowledgeCenter.setKnowledgeCenterDataTrack());
                    
                    }else if(dataFromServer.status=='pushSessionName'){
                        
                        var pushSessionNameData = dataFromServer.data;
                        /**********create data on here**********/
                        console.log(pushSessionNameData, "session name");
                        dispatch( allActions.ModalPopup.pushPopupData({image:"",title:pushSessionNameData,download_link:"",popupname:"feedback"}));


                    }else if(dataFromServer.status=='reload'){
                    
                        window.location.reload(true);
                
                    }
            
                    console.log('From server');
                };
            
            
                client.onclose = function(){
                    console.log("Close Connection!!");
                    setTimeout(function(){ dispatch(allActions.webSocketFunc.webSocketFunc(false));  }, 5000);
                }   
            
                client.onerror = function() {
                    console.log("Error Connection!!");
                    client.close();
                };
            
         
            }

    });
  
}

export {client, OwnWebSocket};
